<div class="mt-10">
    <div class="dark-overlay animate-pulse block flex-grow w-[300px] !rounded-[24px] h-[32px] mb-3"></div>
    <div class="flex items-center flex-nowrap overflow-hidden gap-4">
        <div *ngFor="let item of [].constructor(navigatorVal ? 2 : 6)"
            class="dark-overlay animate-pulse block flex-grow !rounded-[24px] w-[140px] h-[184px]"></div>
    </div>
</div>